import { invalidate, useQueryClient } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import { useState } from "react";
import { client } from "@/hono";

/**
 * Settle a duplicate — merge it into its original, or declare it none — and refresh every reader
 * of it: the invoices, their lists and the caller's approvals.
 */
export function useDecideIncomingInvoiceDuplicate() {
	/** Hooks */
	const qc = useQueryClient();

	/** State */
	const [isDeciding, setIsDeciding] = useState(false);

	/** Functions */
	async function decide(incomingInvoiceId: string, decision: "merge" | "dismiss") {
		try {
			setIsDeciding(true);
			const route = client.incoming_invoices[":incomingInvoiceId"].duplicate;
			const response =
				decision === "merge"
					? await route.merge.$post({ param: { incomingInvoiceId } })
					: await route.dismiss.$post({ param: { incomingInvoiceId } });
			await responseHandler(response);
			await qc.invalidateQueries({
				predicate: invalidate(["incoming-invoices", "incoming-invoice-approvals-mine"]),
			});
		} finally {
			setIsDeciding(false);
		}
	}

	/** Return */
	return { decide, isDeciding };
}
